import {
    instance as axios,
    setJwtToken,
} from "../../config/axiosInstance";

// ---------------------Post-listing--------------------------
export const reportListApi = async (data) => {
    const endPoint =
        `post/report` +
        "?" +
        new URLSearchParams({ ...data }).toString();

    return await axios.get(endPoint, setJwtToken());
};

export const removeReportApi = async (id) => {
    const endPoint = `post/delete_report_content/${id}`;
    return await axios.delete(endPoint, setJwtToken());
};

// ---------------------add-Report-Api--------------------------
export const addReportApi = async (data) => {
    const endPoint = `post/report/respond`;
    return await axios.post(endPoint, data, setJwtToken());
};